import { FiniteListWithAsyncLoaderAbstract, ListProps } from "shared/components/Components";
import { useMercuryContext } from "../../context";

export const fetchParentDepartments = async (context: any) => {
  const { data } = await context.coreClient.get(
    "/core-v1/empower-departments/parent-departments"
  );
  return (data || []).map((item: any) => ({
    _id: item._id,
    departmentName: item.departmentName,
  }));
};

class BaseEmpowerDepartmentFilter extends FiniteListWithAsyncLoaderAbstract {
  async fetch() {
    const departments = await fetchParentDepartments(this.props.context);
    return departments.map((item: any) => ({
      title: item.departmentName,
      value: item._id,
    }));
  }
}

const EmpowerDepartmentFilter = (props: ListProps) => {
  const context = useMercuryContext();
  return <BaseEmpowerDepartmentFilter context={context} {...props} width={350} />;
};

export { EmpowerDepartmentFilter };
